export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11347.5f18b53b.jpg";